"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = void 0;
var _react = _interopRequireWildcard(require("react"));
var _GridModule = _interopRequireDefault(require("./Grid.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Grid = exports.Grid = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  var className = _ref.className,
    children = _ref.children;
  var numChildren = _react.default.Children.count(children);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_GridModule.default.Grid, className),
    ref: ref
  }, children, /*#__PURE__*/_react.default.createElement(Placeholder, {
    numChildren: numChildren
  }));
});

/************************
 * Placeholder
 ***********************/

var Placeholder = _ref2 => {
  var numChildren = _ref2.numChildren;
  if (numChildren < 3) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, Array.from({
      length: 3 - numChildren
    }, (_, i) => /*#__PURE__*/_react.default.createElement("div", {
      key: i,
      "data-testid": "zui-grid-placeholder"
    })));
  } else {
    return null;
  }
};
//# sourceMappingURL=Grid.js.map